import { createContext } from 'react';
export const PracticeReseveContext = createContext<any>(null);
